// extracted by mini-css-extract-plugin
module.exports = {"content":"dp-B47ilRaO","leftContainer":"dp-JC8Iu3fQ","infoContainer":"dp-XvkCw78t","rightContainer":"dp-iDRcRtw7"};